import { render } from "./IBNodeItem.vue?vue&type=template&id=0db4ee59"
import script from "./IBNodeItem.vue?vue&type=script&lang=js"
export * from "./IBNodeItem.vue?vue&type=script&lang=js"
script.render = render

export default script